import {PrintNodeOrder} from "../../../model/PrintNodeOrder";
import {Product} from "../../../model/Product";

export class PickSheetsGroup {
  public type: string;
  public packageType: string;
  public date: string;
  public tag: string;
  public tagType: string;
  public orders: number = 0;
  public orderIds: number[] = [];
  public books: number = 0;
  public titleQuantities: any = {};
  public selected: boolean = false;
  public group: string;

  constructor (obj: any) {
    this.type = '';
    this.packageType = '';
    this.date = '';
    this.tag = '';
    this.tagType = '';
    this.orders = 0;
    this.orderIds = [];
    this.books = 0;
    this.titleQuantities = {};
    this.selected = false;
    this.group = '';

    if ( obj ) {
      for (const prop of Object.keys(obj)) {
        this[prop] = obj[prop];
      }
    }
  }

  public getId() {
    return this.type + '-' + this.packageType + '-' + this.date + '-' + this.tag;
  }

  getIndex () {
    return 0;
  }
}
